import script from "./SideMenuMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenuMobile.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenuMobile.vue?vue&type=style&index=0&id=3fc1c64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc1c64b"]])

export default __exports__